import baseStoreDefaults from '../vqfh8pritw-1/config.js';

export default {
  ...baseStoreDefaults,
  includes: ['vqfh8pritw-1'],
};
